import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { PermissionService } from '../service/permissionService';
import { MessageService } from 'primeng/api';
import { AuthenticatorService } from '../service/authenticatorService';
import { firstValueFrom } from 'rxjs';
import { selectUserPermissions } from '../state/selector';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  private readonly router = inject(Router);
  private readonly authenticatorService = inject(AuthenticatorService);
  private readonly permissionService = inject(PermissionService);
  private readonly messageService = inject(MessageService);
  private readonly store = inject(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  canActivate: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
    const referenceID = route.paramMap.get('id') || null;
    const userPermissions = await firstValueFrom(this.store.select(selectUserPermissions));

    if (userPermissions.length > 0) {
      const hasPermission = await this.permissionService.checkPermission(
        referenceID,
        route.data?.['feature'],
        route.data?.['actions']
      );

      if (hasPermission) {
        return true;
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Forbidden',
          detail: 'Access forbidden. You do not have the necessary permissions.',
        });
        const url = await firstValueFrom(this.authenticatorService.getRedirectUrlBasedOnRole('/'));
        this.router.navigateByUrl(url);
        return false;
      }
    }

    return false;
  };
}
